import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const RugbyLeagueIcon = observer('RugbyLeagueIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M18.9124 2.20052C15.8311 1.36856 10.9826 3.15133 7.06691 7.06701C3.15414 10.9798 1.37115 15.824 2.19862 18.9056C2.31748 18.0638 2.66409 17.065 3.23849 15.9266C4.3971 13.6302 6.3368 11.0639 8.70031 8.70041C12.3169 5.08378 16.3059 2.56361 18.9124 2.20052Z'
                fill='fill'
            />
            <path
                d='M19.584 7.47938C20.6963 5.27465 20.6645 4.06585 20.2993 3.7006C20.1119 3.51316 19.7766 3.47382 19.5284 3.47382C17.6716 3.47382 13.6763 5.5894 9.63281 9.6329C7.3658 11.8999 5.51309 14.346 4.41589 16.5206C3.30353 18.7253 3.33531 19.9341 3.70056 20.2994C3.88795 20.4868 4.22322 20.5261 4.47145 20.5261C6.32812 20.5262 10.3234 18.4107 14.367 14.367C16.634 12.1001 18.4868 9.654 19.584 7.47938Z'
                fill='fill'
            />
            <path
                d='M20.7614 8.07343C21.3358 6.93495 21.6824 5.93613 21.8012 5.09433C22.6287 8.17598 20.8457 13.0201 16.9329 16.9329C13.0172 20.8486 8.16876 22.6314 5.08746 21.7995C7.69388 21.4364 11.6829 18.9162 15.2995 15.2996C17.663 12.9361 19.6027 10.3698 20.7614 8.07343Z'
                fill='fill'
            />
        </SvgElement>
    );
});
